export default {
    fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 600,

    h1: {
        fontSize: '1.875rem',
        fontWeight: 500,
        lineHeight: 1.5,
    },
    h2: {
        fontSize: '1.5rem',
        fontWeight: 500,
        lineHeight: 1.5,
    },
    h3: {
        fontSize: '1.25rem',
        fontWeight: 500,
        lineHeight: 1.5,
    },
    h4: {
        fontSize: '1.125rem',
        fontWeight: 500,
        lineHeight: 1.5,
    },
    h5: {
        fontSize: '1rem',
        fontWeight: 500,
        lineHeight: 1.5,
    },
    h6: {
        fontSize: '0.875rem',
        fontWeight: 500,
        lineHeight: 1.5,
    },
    body1: {
        fontSize: '1rem',
        fontWeight: 400,
        lineHeight: 1.5,
    },
    body2: {
        fontSize: '0.875rem',
        fontWeight: 400,
        lineHeight: 1.5,
    },
    caption: {
        fontSize: '0.75rem',
        fontWeight: 400,
        lineHeight: 1.5,
    },
    button: {
        fontSize: '0.875rem',
        fontWeight: 500,
        lineHeight: 1.5,
        textTransform: 'none',
    },
    overline: {
        fontSize: '0.75rem',
        textTransform: 'uppercase',
        fontWeight: 500,
    },
};